import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import Data from '../../../../data/StateEarnestMoneyAgreement.json';
import converter from 'number-to-words';
import {Title, Noun, Pronoun, SingularPluralForm} from '../../../../model/Helper';
import Loading from '../../../../view/Loading';
import PaperSignatoriesForPdf from '../../../../model/PaperSignatoriesForPdf';
import PaperSignatoriesAcknowledgementForPdf from '../../../../model/PaperSignatoriesAcknowledgementForPdf';
import RequiredData from '../../../../model/RequiredData';
import PaperPartyPdf from '../../../../model/PaperPartyPdf';
import FormFinal from '../../../../view/FormFinal';
import moment from 'moment';
import Meta from '../../../../model/Meta';

class EarnestMoneyAgreementStep6 extends Component {

    constructor(props){
        super(props);
        this.state = Data;
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
                    RequiredData.property(this.state, this.state.formPath+"/1");
                    RequiredData.seller(this.state, this.state.formPath+"/2");
                    RequiredData.buyer(this.state, this.state.formPath+"/3");
                    RequiredData.earnestMoney(this.state, this.state.formPath+"/4");

					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log("State default: ", this.state);
			//console.log("Storage default: ", data);
		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {
        // Data
        let p = this.state.details.property;
        let s = this.state.details.seller;
        let b = this.state.details.buyer;
        let pa = this.state.details.payment;

        let nounSeller = Noun(s, "seller");
        let nounBuyer = Noun(b, "buyer");

        let blankLine = "____________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;
        let contractDate = moment(p.contractDate).format(`LL`) || blankLine;
        let contractLocation = p.contractLocation || blankLine;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        s.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
            sellerCorporationRepresentativePosition[i] = seller.sellerCorporationRepresentativePosition ? seller.sellerCorporationRepresentativePosition : blankLine;
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [],
            buyerCorporationRepresentativePosition = [];
        b.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : ""; 
            buyerCorporationRepresentativePosition[i] = buyer.buyerCorporationRepresentativePosition ? buyer.buyerCorporationRepresentativePosition : blankLine;
        });

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                Number(p.price).toLocaleString() :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;
        
        let earnestMoneyAmountNumber = (typeof parseFloat(p.earnestMoneyAmount) === "number" && parseFloat(p.earnestMoneyAmount)>0) ?
                            Number(p.earnestMoneyAmount).toLocaleString() :
                            blankLine;		
        let earnestMoneyAmountText = (typeof parseFloat(p.earnestMoneyAmount) === "number" && parseFloat(p.earnestMoneyAmount)>0) ?
                            converter.toWords(p.earnestMoneyAmount) : 
                            blankLine;

        let daysReservedNumber = (typeof parseFloat(p.daysReserved) === "number" && parseFloat(p.daysReserved)>0) ?
                            Number(p.daysReserved).toLocaleString() :
                            blankLine;		
        let daysReservedText = (typeof parseFloat(p.daysReserved) === "number" && parseFloat(p.daysReserved)>0) ?
                        converter.toWords(p.daysReserved) : 
                        blankLine;

        let buyersPayArray = [];
        let sellersPayArray = [];
        pa.capitalGainTax === "seller" ?
            sellersPayArray.push("capital gain tax"):
            buyersPayArray.push("capital gain tax");
        pa.documentaryStampTax === "seller" ?
            sellersPayArray.push("documentary stamp tax"):
            buyersPayArray.push("documentary stamp tax");
        pa.transferTax === "seller" ?
            sellersPayArray.push("transfer tax"):
            buyersPayArray.push("transfer tax");
        pa.registrationFee === "seller" ?
            sellersPayArray.push("registration fee"):
            buyersPayArray.push("registration fee");
        pa.notarialFee === "seller" ?
            sellersPayArray.push("notarial fee") :
            buyersPayArray.push("notarial fee");
        if(pa.hasBroker === "Yes"){
            pa.brokerCommission === "seller" ?
                sellersPayArray.push("broker's commission") :
                buyersPayArray.push("broker's commission");
        }
        pa.creditableWithholdingTax === "seller" ?
            sellersPayArray.push("creditable withholding tax") :
            buyersPayArray.push("creditable withholding tax");
        pa.valueAddedTax === "seller" ?
            sellersPayArray.push("value added tax") :
            buyersPayArray.push("value added tax");
        let sellersPay = sellersPayArray.join(", ");
        let buyersPay = buyersPayArray.join(", ");

        let contract_html = `
        <style type="text/css">
			@import url("./css/styles.css");
            @import url("./css/styles-custom.css");
		</style>

        <div class="pdf">

            <div class="paper">
                
                <div class="paper-title text-center">
                    Earnest Money Agreement
                </div>

                <div class="text-uppercase">
                    KNOW ALL MEN BY THESE PRESENTS:
                </div>

                <div class="padding10">
                    <p>This Earnest Money Agreement (hereinafter “Agreement”) made and entered into this <span class="text-capitalize">${contractDate}</span> in <span class="text-capitalize">${contractLocation}</span>, Philippines, by and between:</p>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(s, "seller")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3">- and -</div>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(b, "buyer")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3"><strong>WITNESSETH</strong>: That-</div>
                </div>

                <div class="py-3">
                    <p>1.     For and in consideration of the Earnest Money amounting to <span class="text-uppercase">${earnestMoneyAmountText} PESOS (P${earnestMoneyAmountNumber})</span> Philippine Currency, the <span class="text-uppercase">${nounSeller}</span> hereby ${SingularPluralForm(nounSeller, "reserve")} the exclusive right to purchase the real property covered by <span class="text-uppercase">${title}</span> (hereinafter "Subject Real Property"), located at <span class="text-capitalize">${pAddress}</span>, and amounting to <span class="text-uppercase">${priceText} PESOS (P${priceNumber})</span> Philippine Currency, in favor of the <span class="text-uppercase">${nounBuyer}</span> <span class="font-weight-bold text-underline"><u>effective for ${daysReservedText} (<span class="dynamic-data">${daysReservedNumber}</span>) days</u></span> from execution of this Agreement.
                    </p>
                </div>

                <div class="py-3">
                    <p>2.     The <span class="text-uppercase">${nounSeller}</span> ${SingularPluralForm(nounSeller, "guarantee")} that under this Agreement, ${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} will not offer for sale, the Subject Real Property, to any third party during the aforesaid <span class="dynamic-data">${daysReservedNumber}-day</span> period.
                    </p>
                </div>

                <div class="py-3">
                    <p>3.     Should the <span class="text-uppercase">${nounBuyer}</span> ${SingularPluralForm(nounBuyer, "decide")} to push through with the purchase of the Subject Real Property and execute a Contract to Sell or Deed of Absolute Sale with the <span class="text-uppercase">${nounSeller}</span>, within the <span class="dynamic-data">${daysReservedNumber}-day</span> period provided in this Agreement, the Earnest Money shall be deemed to form part of the purchase price.
                    </p>
                </div>

                <div class="py-3">
                    <p>4.     It is likewise understood that the <span class="text-uppercase">${nounBuyer}</span> shall obligate ${Pronoun("himself", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} to pay${buyersPayArray.length>0?`<span> the <span class="dynamic-data">${buyersPay}</span>, and </span>`:` `}other necessary expenses connected to the issuance of the corresponding title for the Subject Real Property in ${Pronoun("himself", b[0].buyerGender, b[0].legalPersonality, nounBuyer)} name. 
                    </p>
                    <p>       On the other hand${sellersPayArray.length>0?`<span>, the </span>`:``}<span class="dynamic-data">${sellersPay}</span>, whichever is applicable, shall be for the account of the <span class="text-uppercase">${nounSeller}</span>.
                    </p>
                </div>

                <div class="py-3">
                    <p>5.     After the lapse of the <span class="dynamic-data">${daysReservedNumber}-day</span> period or voluntary cancellation of this Agreement by the <span class="text-uppercase">${nounBuyer}</span>, without any cause on the part of the <span class="text-uppercase">${nounSeller}</span>, this Agreement shall be deemed automatically terminated, in which case, the Earnest Money shall be forfeited in favor of the <span class="text-uppercase">${nounSeller}</span> as liquidated damages.
                    </p>
                </div>

                <div class="py-3">
                    <p>
                        IN WITNESS WHEREOF, the parties have executed this Earnest Money Agreement this <span class="text-capitalize">${contractDate}</span> in <span class="text-capitalize">${contractLocation}</span>.
                    </p>
                </div>

                <br />

                <div>
                    ${PaperSignatoriesForPdf(s, b)}
                </div>

                <br />
                <br />
                <br />

                <div class="mt-5">
                    <div>
                        Signed in the presence of:
                    </div>
                    <table class="table-even mt-5">
                        <tr>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                        </tr>
                    </table>
                </div>  

            </div>

            <div class="paper" style="page-break-before: always;">
                
                <table class="table-even">
                    <tr>
                        <td>
                            <table>
                                <tr><td><div class="pr-25">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
                                <tr><td><div class="text-right">)S.S.</div></td></tr>
                            </table>
                        </td>
                        <td>
                        </td>
                    </tr>
                </table>

                <div class="paper-title text-center">
                    Acknowledgement
                </div>

                <div>
                    <p>
                        BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                    </p>
                </div>

                ${PaperSignatoriesAcknowledgementForPdf(s, b)}

                <div>
                    <p>
                        Known to me and to me known to be the same persons who executed the foregoing Earnest Money Agreement consisting of [PAGES] pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                    </p>
                    <p>
                        WITNESS MY HAND AND SEAL in the place and on the date first above written.
                    </p>
                </div>

                <br />
                <br />
                <div class="docno">
                    Doc No. ________; <br />
                    Page No. _______; <br />
                    Book No. _______; <br />
                    Series of 20 ___. <br />
                </div>	

            </div>

        </div>`;

        let fn = "earnest_money_agreement_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
			title: "Your Earnest Money Agreement Contract is now ready",
			description: "Your Earnest money agreement contract is now ready for download"
		}
        
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((6/6)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 6/6</p>
									<Link to={this.state.formPath+"/5"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default EarnestMoneyAgreementStep6;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/earnest-money-agreement/EarnestMoneyAgreementStep6.js